import adminConstants from '../constants/adminConstants';

const initialState = {
  gettingApplications: false,
  applications: [],
  submittingApplication: false,
  undoingPMApproval: false,
  changingApplicationOwner: false,
  gettingUsers: false,
  deactivatingUser: false,
  reactivatingUser: false,
  users: [],
  roles: [],
  claims: [],
  territoryTypes: [],
  territories: [],
  gettingRoles: false,
  gettingTerritories: false,
  gettingTerritoryTypes: false,
  gettingUserAssignedTerritories: false,
  savingUserEdits: false,
  updatingTerritoryAssignment: false,
  updatingPermitTypeLocationAssignments: false,
  gettingUserAssignedPermitTypeLocations: false,
};

function admin(state = initialState, action) {
  let usersCopy = [];
  let userIndex = -1;
  switch (action.type) {
    case adminConstants.getAdminApplications:
      return { ...state, gettingApplications: true };
    case adminConstants.getAdminApplicationsSucceeded:
      return { ...state, gettingApplications: false, applications: action.applications };
    case adminConstants.getAdminApplicationsFailed:
      return { ...state, gettingApplications: false };

    case adminConstants.submitApplication:
      return { ...state, submittingApplication: true };
    case adminConstants.submitApplicationSucceeded:
      return { ...state, submittingApplication: false };
    case adminConstants.submitApplicationFailed:
      return { ...state, submittingApplication: false };

    case adminConstants.undoPMApproval:
      return { ...state, undoingPMApproval: true };
    case adminConstants.undoPMApprovalSucceeded:
      return { ...state, undoingPMApproval: false };
    case adminConstants.undoPMApprovalFailed:
      return { ...state, undoingPMApproval: false };

    case adminConstants.changeApplicationOwner:
      return { ...state, changingApplicationOwner: true };
    case adminConstants.changeApplicationOwnerSucceeded:
      return { ...state, changingApplicationOwner: false };
    case adminConstants.changeApplicationOwnerFailed:
      return { ...state, changingApplicationOwner: false };

    case adminConstants.getUsers:
      return { ...state, gettingUsers: true };
    case adminConstants.getUsersSucceeded:
      return { ...state, gettingUsers: false, users: [...action.users] };
    case adminConstants.getUsersFailed:
      return { ...state, gettingUsers: false };

    case adminConstants.deactivateUser:
      return { ...state, deactivatingUser: true };
    case adminConstants.deactivateUserSucceeded:
      const deactivateUsersCopy = [...state.users];
      const deactivatedUserIdx = deactivateUsersCopy.findIndex((u) => u.id === action.userId);
      if (deactivatedUserIdx === -1) {
        console.warn('Did not find deactivated user in users list');
        return { ...state, reactivatingUser: false };
      }
      deactivateUsersCopy[deactivatedUserIdx].isDeactivated = true;
      return { ...state, deactivatingUser: false, users: [...deactivateUsersCopy] };
    case adminConstants.deactivateUserFailed:
      return { ...state, deactivatingUser: false };

    case adminConstants.reactivateUser:
      return { ...state, reactivatingUser: true };
    case adminConstants.reactivateUserSucceeded:
      const reactivateUsersCopy = [...state.users];
      const reactivatedUserIdx = reactivateUsersCopy.findIndex((u) => u.id === action.userId);
      if (deactivatedUserIdx === -1) {
        console.warn('Did not find deactivated user in users list');
        return { ...state, reactivatingUser: false };
      }
      reactivateUsersCopy[reactivatedUserIdx].isDeactivated = false;
      return { ...state, reactivatingUser: false, users: [...reactivateUsersCopy] };
    case adminConstants.reactivateUserFailed:
      return { ...state, reactivatingUser: false };

    case adminConstants.getRoles:
      return { ...state, gettingRoles: true };
    case adminConstants.getRolesSucceeded:
      return { ...state, gettingRoles: false, roles: [...action.roles] };
    case adminConstants.getRolesFailed:
      return { ...state, gettingRoles: false };

    case adminConstants.getClaims:
      return { ...state, gettingClaims: true };
    case adminConstants.getClaimsSucceeded:
      return { ...state, gettingClaims: false, claims: [...action.claims] };
    case adminConstants.getClaimsFailed:
      return { ...state, gettingClaims: false };

    case adminConstants.getTerritoryTypes:
      return { ...state, gettingTerritoryTypes: true };
    case adminConstants.getTerritoryTypesSucceeded:
      return { ...state, gettingTerritoryTypes: false, territoryTypes: [...action.territoryTypes] };
    case adminConstants.getTerritoryTypesFailed:
      return { ...state, gettingTerritoryTypes: false };

    case adminConstants.getTerritories:
      return { ...state, gettingTerritories: true };
    case adminConstants.getTerritoriesSucceeded:
      return { ...state, gettingTerritories: false, territories: [...action.territories] };
    case adminConstants.getTerritoriesFailed:
      return { ...state, gettingTerritories: false };

    case adminConstants.getUserAssignedTerritories:
      return {
        ...state,
        gettingUserAssignedTerritories: true,
      };
    case adminConstants.getUserAssignedTerritoriesSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedTerritories = action.assignedTerritories;
      }
      return {
        ...state,
        users: [...usersCopy],
        gettingUserAssignedTerritories: false,
      };

    case adminConstants.getUserAssignedTerritoriesFailed:
      return { ...state, gettingUserAssignedTerritories: false };

    case adminConstants.saveUserEdits:
      return { ...state, savingUserEdits: true };
    case adminConstants.saveUserEditsSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].contractorId = action.contractorId;
        usersCopy[userIndex].userRoles = action.roleIds.map((roleId) => {
          return {
            roleId,
          };
        });
        usersCopy[userIndex].userClaims = action.claimIds.map((claimId) => {
          return { ...state.claims.find((c) => c.id === claimId), claimId };
        });
      }
      return {
        ...state,
        users: [...usersCopy],
        savingUserEdits: false,
      };
    case adminConstants.saveUserEditsFailed:
      return { ...state, savingUserEdits: false };

    case adminConstants.assignTerritories:
      return { ...state, updatingTerritoryAssignment: true };
    case adminConstants.assignTerritoriesSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedTerritories = [
          ...usersCopy[userIndex].assignedTerritories,
          ...action.assignedTerritories,
        ];
      }
      return { ...state, users: [...usersCopy], updatingTerritoryAssignment: false };
    case adminConstants.assignTerritoriesFailed:
      return { ...state, updatingTerritoryAssignment: false };

    case adminConstants.unassignTerritories:
      return { ...state, updatingTerritoryAssignment: true };
    case adminConstants.unassignTerritoriesSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedTerritories = usersCopy[userIndex].assignedTerritories.filter(
          (t) => !action.unassignedTerritoryIds.includes(t.id)
        );
      }
      return { ...state, users: [...usersCopy], updatingTerritoryAssignment: false };
    case adminConstants.unassignTerritoriesFailed:
      return { ...state, updatingTerritoryAssignment: false };

    case adminConstants.getUserAssignedPermitTypeLocations:
      return { ...state, gettingUserAssignedPermitTypeLocations: true };
    case adminConstants.getUserAssignedPermitTypeLocationsSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedPermitTypeLocations = action.assignedPermitTypeLocations;
      }
      return { ...state, users: [...usersCopy], gettingUserAssignedPermitTypeLocations: false };
    case adminConstants.getUserAssignedPermitTypeLocationsFailed:
      return { ...state, gettingUserAssignedPermitTypeLocations: false };

    case adminConstants.assignPermitTypeLocations:
      return { ...state, updatingPermitTypeLocationAssignments: true };
    case adminConstants.assignPermitTypeLocationsSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedPermitTypeLocations = [
          ...usersCopy[userIndex].assignedPermitTypeLocations,
          ...action.assignedPermitTypeLocations,
        ];
      }
      return { ...state, users: [...usersCopy], updatingPermitTypeLocationAssignments: false };
    case adminConstants.assignPermitTypeLocationsFailed:
      return { ...state, updatingPermitTypeLocationAssignments: false };

    case adminConstants.unassignPermitTypeLocations:
      return { ...state, updatingPermitTypeLocationAssignments: true };
    case adminConstants.unassignPermitTypeLocationsSucceeded:
      usersCopy = [...state.users];
      userIndex = usersCopy.findIndex((u) => u.id === action.userId);
      if (userIndex !== -1) {
        usersCopy[userIndex].assignedPermitTypeLocations = usersCopy[
          userIndex
        ].assignedPermitTypeLocations.filter(
          (combo) =>
            !action.unassignedPermitTypeLocations.some(
              (unassignedCombo) =>
                unassignedCombo.permitTypeId === combo.permitTypeId &&
                unassignedCombo.territoryId === combo.territoryId
            )
        );
      }
      return { ...state, users: [...usersCopy], updatingPermitTypeLocationAssignments: false };
    case adminConstants.unassignPermitTypeLocationsFailed:
      return { ...state, updatingPermitTypeLocationAssignments: false };

    default:
      return state;
  }
}

export default admin;
